import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import * as utilities from '#utilities/js/styles.js'
import { elements, modifiers } from '../styles.js'
import prepend from '@mailobj-browser/front/js/tree/prepend.js'
import replaceWith from '@mailobj-browser/front/js/tree/replaceWith.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import preventDefault
  from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import { close } from '#utilities/js/lightboxes/menus/menu.js'

export const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: (
    anchor
  ) => {
    requestAnimationFrame(() => {
      const { dataset, ownerDocument } = anchor
      const { target } = dataset
      const modal = one(`.${elements.modal}`, ownerDocument)
      const anchorText = one(`.${elements.button_text}`, anchor)
      const tabsName = target.substring(0, target.indexOf('_'))
      const tabName = target.substring(target.indexOf('_') + 1, target.length)
      let tabsNavigation = one(`[data-tabs="${tabsName}"] .${elements.nav}`, ownerDocument)

      if (modal) {
        tabsNavigation = one(`[data-tabs="${tabsName}"] .${elements.nav}`, modal)
      }

      if (tabsNavigation) {
        const tabsContainer = closest(`.${elements.tabs}`, tabsNavigation)
        const opener = one(`.${utilities.modifiers.lightbox.dropdown}`, tabsNavigation)
        const list = one(`.${elements.nav_list}`, tabsNavigation)

        one(`.${modifiers.button.active}`, list)?.classList.remove(modifiers.button.active)
        one(`.${modifiers.button.active}`, list)?.removeAttribute('aria-selected')
        one(`a[data-target="${target}"]`, list)?.classList.add(modifiers.button.active)
        one(`a[data-target="${target}"]`, list)?.setAttribute('aria-selected', 'true')
        one(`.${elements.tab_panel}:not(.${utilities.modifiers.display.none})`, tabsContainer)?.classList.add(utilities.modifiers.display.none)
        one(`.${elements.tab_panel}[data-tab="${tabName}"]`, tabsContainer)?.classList.remove(utilities.modifiers.display.none)

        if (opener) {
          const { content } = one('template', opener)
          const openerText = one(`.${elements.button_text}`, opener)
          const cloneAnchorText = anchorText.cloneNode(true)
          const currentItemActive = one(`a[aria-selected='true']`, content)
          const itemActive = one(`a[data-target='${target}']`, content)

          currentItemActive?.removeAttribute('aria-selected')
          itemActive?.setAttribute('aria-selected', 'true')

          replaceWith(openerText, cloneAnchorText)

          close()
        }
      }
    })
  }
})

export default anchor => {
  onClick.listen(anchor)
}
